var smartform = smartform || {};
smartform.beforeInit = function () {
    smartform.setClientId('RAdQmwnv0k');
}

smartform.afterInit = function () {
    smartform.getInstance().addAnnounceCallback(announceCallback);
}

function announceCallback(validationType, addressArray) {
    if (validationType === smartform.ValidationResultType.HIT && addressArray[0] !== undefined) {
        var address = $('#adresa');
        address.data('long', addressArray[0].GPS_LONG);
        address.data('lat', addressArray[0].GPS_LAT);
    }
}
